import { useEffect, useState } from 'react';
import { buildApiUrl } from '../../common/api';

let cachedConfig = null;
let fetchPromise = null;

async function fetchShopConfig() {
  if (cachedConfig) return cachedConfig;
  if (!fetchPromise) {
    fetchPromise = fetch(buildApiUrl('/api/config/shop'), {
      headers: { Accept: 'application/json' },
    })
      .then((r) => r.json())
      .then((j) => {
        cachedConfig = {
          catalogo_live: Boolean(j.catalogo_live),
          catalogo_preview: Boolean(j.catalogo_preview ?? !j.catalogo_live),
        };
        return cachedConfig;
      })
      .catch(() => {
        cachedConfig = { catalogo_live: false, catalogo_preview: true };
        return cachedConfig;
      })
      .finally(() => {
        fetchPromise = null;
      });
  }
  return fetchPromise;
}

export function useShopConfig() {
  const [config, setConfig] = useState(cachedConfig || { catalogo_live: false, catalogo_preview: true, loading: true });

  useEffect(() => {
    let active = true;
    fetchShopConfig().then((data) => {
      if (active) setConfig({ ...data, loading: false });
    });
    return () => { active = false; };
  }, []);

  return config;
}
